
export const mountKareScript = (document) => {
    const kareScriptExists = document.getElementById('kareScript');
    if (!kareScriptExists) {
        const kareScript = document.createElement('script');
        kareScript.setAttribute('src', 'https://widget.eu.karehq.com/kare_loader.js?appId=5edb81b6-7381-427a-9085-99a4f540898e');
        kareScript.setAttribute('id', 'kareScript');
        document.head.appendChild(kareScript);
    }
};

const removeFromHtml = (element) => {
    return element && element.parentElement.removeChild(element);
};

export const removeKare = (document) => {
    const kareScript = document.querySelectorAll('script[src^="https://widget.eu.karehq.com/kare_loader.js?appId=5edb81b6-7381-427a-9085-99a4f540898e"]');
    removeFromHtml(kareScript[0]);
    const kareWidgetScript = document.querySelectorAll('script[src^="https://widget.eu.karehq.com/latest.js"]');
    removeFromHtml(kareWidgetScript[0]);
    const kareWidget = document.querySelectorAll('.glr-widget');
    removeFromHtml(kareWidget[0]);
};
